import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import { Routes } from '@/constants';
import { AnalyticsService } from '@/services';
import { useFetchOrganizationMembershipSummaryQuery } from '@/store';

import { SummaryTile } from '../SummaryTile';

const title = 'Accepted Invites';
const description =
  'Percentage of invited members who created a LumiQ account and joined the team.';
const Cta = () => {
  const navigate = useNavigate();
  return (
    <Button
      label="See Members"
      size="small"
      fullWidth={false}
      onClick={() => {
        AnalyticsService.seeMembersClicked();
        navigate(Routes.MEMBER_MANAGEMENT);
      }}
    />
  );
};

export const AcquiredMembers = () => {
  const { data: membershipSummary, isFetching } =
    useFetchOrganizationMembershipSummaryQuery();

  const { acceptedInvites = 0, totalNonRemovedMembers = 0 } =
    membershipSummary || {};

  const percentage = `${Math.round(
    (acceptedInvites / totalNonRemovedMembers) * 100 || 0,
  )}%`;

  return (
    <SummaryTile
      title={title}
      mainStat={percentage}
      description={description}
      Cta={Cta}
      isLoading={isFetching}
    />
  );
};
